import { toast } from "react-toastify";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable, MASK_DATE, MASK_NUMBER } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { useEffect, useState } from "react";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { _single, _TaxEntityConsecutive } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { AccountEditor } from "../../../editor/AccountEditor";
import { SelectUBLDocumentTypeConstants } from "../../CatalogoDocumentosUBL/Selectores/SelectUBLDocumentTypeConstants";
import { InputDate } from "../../../theme/Input/InputDate";
import { BasicSwitch } from "../../../theme/Component/BasicSwitch";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { _ConsecutiveSequence } from "../../../../core/services/dataBean/EntityCatalogVdos";

interface Form {
    IDAccount: number;
    UBLDocumentType: number;
    Date: any;
}

export const TaxEntityConsecutive = () => {

    const { lista, setLista, bean, setBean, instance, update, handleChange, deleteItemVoid } = useDataBean(_TaxEntityConsecutive);
    const sequnce = useDataBean(_ConsecutiveSequence);
    const [form, setForm] = useState<Form>({
        IDAccount: null,
        Date: _single.getCurrenDate(),
        UBLDocumentType: null
    })

    const [modalsec, setModalsec] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    const getLista = () => {
        instance.getTaxEntityConsecutiveByAccount(form.IDAccount, form.UBLDocumentType, form.Date).then(
            (rta: any) => {
                setLista(rta)
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    const editaItem = () => {
        update().then(
            (resp) => {
                getLista();
                setModal({ ...modal, "view": false })
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    const deleteObjec = () => {
        deleteItemVoid(bean.IDTaxEntityConsecutive).then(
            (resp) => {
                getLista();
                setModalC({ ...modalC, "view": false })
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    const head = [
        { title: 'ID', property: 'IDTaxEntityConsecutive', visible: true, mask: MASK_NUMBER },
        { title: 'Facturador', property: 'AccountName', visible: true },
        { title: 'Tipo Documento', property: 'UBLDocumentTypeName', visible: true },
        { title: 'Número de Autorización', property: 'AuthorizationNumber', visible: true },
        { title: 'Prefijo', property: 'NumerationPrefix', visible: true },
        { title: 'Valor Actual', property: 'SequenceActualValue', visible: true,mask:MASK_NUMBER },
        { title: 'Consecutivo Inicial', property: 'InitialConsecutive', visible: true, mask: MASK_NUMBER },
        { title: 'Consecutivo final', property: 'UptoConsecutive', visible: true, mask: MASK_NUMBER },
        { title: 'Fecha Inicio', property: 'FromDate', visible: true, mask: MASK_DATE },
        { title: 'Fecha Final', property: 'UptoDate', visible: true, mask: MASK_DATE },
        { title: 'Fecha de Autorización', property: 'AuthorizationDate', visible: true, mask: MASK_DATE },
        { title: 'Clave Técnica', property: 'TechnicalKey', visible: true },
        { title: 'Habilitado', property: 'IsEnabled', visible: true },
    ]

    const create = () => {
        setBean({
            IsEnabled: false
        });
        setModal({ ...modal, "view": true, "name": "Agregar Numeración Autorizada" });
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Crear/Modificar Secuencia', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { setModalsec({ ...modalsec, "view": true }) } },
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { setModal({ ...modal, "view": true, "name": "Editar Numeración Autorizada" }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true, "name": `Eliminar Numeración Autorizada` }) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const [missingFields, setMissingFields] = useState<string[]>([]);

    const validateData = () => {
        if (validateForm() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            editaItem();
        }
    }
    const createEntityConsecutiveSequence = () => {
        sequnce.instance.createEntityConsecutiveSequence(bean.IDTaxEntityConsecutive, sequnce.bean.ActualConsecutive).then(
            (resp: any) => {
                getLista();
                console.log(resp)
                setModalsec({ ...modalsec, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const validateForm = () => {
        const requiredFields = [
            "IDAccount", "UBLDocumentType", "AuthorizationNumber", "NumerationPrefix", "InitialConsecutive", "UptoConsecutive", "FromDate", "UptoDate"
        ];

        let missing = [];
        for (let field of requiredFields) {
            if (bean[field] === null || bean[field] === undefined || bean[field] === "") {
                missing.push(field);
            }
        }
        setMissingFields(missing);
        return missing.length;
    };

    return (
        <div className="row">
            <div className="col-md-12">
                <BasicPage titulo="Numeración Autorizada" >
                    <div className="row">
                        <div className="col-md-4">
                            <AccountEditor idAccount={form.IDAccount} label="Facturador" onChange={(e) => { setForm({ ...form, "IDAccount": e.IDAccount }) }} />
                        </div>
                        <div className="col-md-3">
                            <SelectUBLDocumentTypeConstants idSelect={form.UBLDocumentType} onChange={(e) => { setForm({ ...form, "UBLDocumentType": e }) }} label="Tipo de Documento" />
                        </div>
                        <div className="col-md-3">
                            <InputDate label="Fecha" value={form.Date} setDate={(e) => { setForm({ ...form, "Date": e }) }} name="Date" />
                        </div>
                        <div className="col-md-2 mt-4">
                            <BasicButton icon="" eventClick={(e) => {
                                if (form.IDAccount && form.Date) {
                                    getLista()
                                } else {
                                    toast.error("Campos Obligatorios: Fecha y Facturador")
                                }
                            }} children={"Buscar"} />
                        </div>
                        <div className="col-md-12">
                            <BasicTable listButtons={listaBotones()} head={head} body={lista} rowSet={setBean} iconButtons={iconButtonsItem} />
                        </div>
                    </div>
                </BasicPage>
            </div>
            <div className="col-md-12">
                <Modal modal={modalsec} updateModal={setModalsec} eventModal={createEntityConsecutiveSequence}>
                    <div className="row">
                        <div className="col-md-12">
                            <label>Consecutivo Actual en Uso</label>
                            <input type="text" className="form-control" value={sequnce.bean.ActualConsecutive} onChange={(e) => { sequnce.setBean({ ...sequnce.bean, 'ActualConsecutive': parseInt(e.target.value) }) }} />
                        </div>
                    </div>
                </Modal>
            </div>
            <div className="col-md-12">
                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteObjec}>
                    <strong>Eliminar {bean.IDTaxEntityConsecutive} - {bean.UBLDocumentTypeName}</strong>
                </ModalConfirm>
            </div>

            <div className="col-md-12">
                <Modal modal={modal} updateModal={setModal} eventModal={validateData}>
                    <div className="row">
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('IDAccount') ? 'has-error' : ''}`}>Facturador</label>
                            <AccountEditor idAccount={bean.IDAccount} onChange={(e) => { setBean({ ...bean, "IDAccount": e.IDAccount }) }} label=" " />
                        </div>
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('UBLDocumentType') ? 'has-error' : ''}`}>Tipo de Documento</label>
                            <SelectUBLDocumentTypeConstants idSelect={bean.UBLDocumentType} onChange={(e) => { setBean({ ...bean, "UBLDocumentType": e }) }} label=" " />
                        </div>
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('AuthorizationNumber') ? 'has-error' : ''}`}>Número de Autorización</label>
                            <input type="text" className="form-control" name="AuthorizationNumber" value={bean.AuthorizationNumber} onChange={handleChange} />
                        </div>
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('NumerationPrefix') ? 'has-error' : ''}`}>Prefijo</label>
                            <input type="text" className="form-control" name="NumerationPrefix" value={bean.NumerationPrefix} onChange={handleChange} />
                        </div>
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('InitialConsecutive') ? 'has-error' : ''}`}>Consecutivo Inicial</label>
                            <input type="number" className="form-control" name="InitialConsecutive" value={bean.InitialConsecutive} onChange={handleChange} />
                        </div>
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('UptoConsecutive') ? 'has-error' : ''}`}>Consecutivo final</label>
                            <input type="number" className="form-control" name="UptoConsecutive" value={bean.UptoConsecutive} onChange={handleChange} />
                        </div>
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('FromDate') ? 'has-error' : ''}`}>Fecha Inicio</label>
                            <InputDate label=" " value={bean.FromDate} setDate={(e) => { setBean({ ...bean, "FromDate": e }) }} name="DateFrom" />
                        </div>
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('UptoDate') ? 'has-error' : ''}`}>Fecha final</label>
                            <InputDate label=" " value={bean.UptoDate} setDate={(e) => { setBean({ ...bean, "UptoDate": e }) }} name="DateUpto" />
                        </div>
                        <div className="col-md-6">
                            <BasicSwitch estado={bean.IsEnabled} eventChange={(e) => { setBean({ ...bean, "IsEnabled": e }) }} label="Habilitado" />
                        </div>
                    </div>
                </Modal>
            </div>
        </div>
    )
}